import { render, staticRenderFns } from "./publishTask.vue?vue&type=template&id=8b03dd80&scoped=true&"
import script from "./publishTask.vue?vue&type=script&lang=js&"
export * from "./publishTask.vue?vue&type=script&lang=js&"
import style0 from "./publishTask.vue?vue&type=style&index=0&id=8b03dd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b03dd80",
  null
  
)

export default component.exports